<div class="row justify-content-center">
    <div class="col-md-6 col-xs-12 text-center heading mat-elevation-z8">
        <h1 class="coolfont">Your Orders</h1>
    </div>
</div>
<div class="row justify-content-center">
    <div class="col-md-6 col-xs-12">
          <table class="mat-elevation-z8 text-center table table-striped table-hover">
              <thead>
                  <tr>
                       <th>Plan </th>
                       <th>Total</th>
                  </tr>
            </thead>
            <tbody>
                <tr *ngFor='let order of orders'>
                    <td>{{order.pname}} @ {{order.speed}}</td>
                    <td>Rs. {{order.total}}</td>
                </tr>
            </tbody>
          </table>
        
    </div>
</div>
<div class="row justify-content-center mt-3">
    <div class="col-md-6 col-xs-12">
        <button mat-raised-button class="bluebtn" (click)='goHome()'>Home</button>
    </div>
</div>